import React, { useCallback } from 'react';

import { usePreviewPanelsActions } from '@atlassian/preview-panels-api';

import { type PanelDataMap, type PARENT_PRODUCTS } from '../common/constants';

import ConfluencePagePreviewPanel from './confluence-page-preview-panel';

export const useConfluencePagePreviewPanel = (
	parentProduct: (typeof PARENT_PRODUCTS)[keyof typeof PARENT_PRODUCTS],
	cloudId?: string,
	onClose?: () => void,
): {
	closeConfluencePagePreviewPanel: () => void;
	openConfluencePagePreviewPanel: (
		url: string,
		onOpen?: () => void,
		panelData?: PanelDataMap,
	) => void;
} => {
	const { open, close } = usePreviewPanelsActions();

	const openConfluencePagePreviewPanel = useCallback(
		(url: string, onOpen?: () => void, panelData?: PanelDataMap): void => {
			open({
				panel: {
					id: `confluence-page-preview-panel_${url.split('/').pop()}`,
					type: 'confluence-page',
					content: () => (
						<ConfluencePagePreviewPanel
							props={{ url, parentProduct, cloudId, panelData }}
							entryPoints={{}}
							extraProps={{}}
							queries={{}}
						/>
					),
					product: 'confluencePreviewPanel',
				},
				onOpen,
			});
		},
		[open, parentProduct, cloudId],
	);

	const closeConfluencePagePreviewPanel = useCallback((): void => {
		close(onClose);
	}, [close, onClose]);

	return { openConfluencePagePreviewPanel, closeConfluencePagePreviewPanel };
};
